import React from 'react'
import { VStack } from 'native-base';
import CompHeader from '../../commons/CompHeader/CompHeader';
import AdminOffersTabs from './AdminOffersTabs';
import { useNavigate } from 'react-router-dom';
import useFetch from '../../hook/useFetch';
import { getSuggestedAdminOffers } from '../../apis/admin';
import DataTable from '../../commons/DataTable/DataTable';
import { suggestionsAdminOffersColumns } from './static';

const SuggestedAdminOffers = () => {
    const navigate = useNavigate()

    const { data, isLoading } = useFetch({
        name: "getSuggestedAdminOffers",
        service: getSuggestedAdminOffers,
        pagination: true
    })

    return (
        <VStack>
            <CompHeader title="Admin Offers"
                buttonTitle='Add Offer'
                onPress={() => navigate('/admin/system_offers/create')}
            />
            <AdminOffersTabs as='suggested' />
            <DataTable tableData={{ columns: suggestionsAdminOffersColumns(navigate), data, pagination: true, isLoading }} />
        </VStack>
    )
}

export default SuggestedAdminOffers